import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";
import type { ICaaOrder } from "@repo/shopify/queries/customer-account-gql";
import { extractId } from "@repo/shopify/utils/common";
import { OrderStatusTrans, getTrackingInfoCaa } from "@repo/shopify/utils/order";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import Image from "@atoms/Image";
import Link from "@atoms/Link";
import Price from "@atoms/Price";

import { URLS } from "@const/urls";

import useOrderStatusCaa from "@hooks/useOrderStatusCaa";

// classic OrderHistoryCard와 동일한 레이아웃이지만 jp는 반품(RETURN)과 주문 취소(CANCEL) 모두 제공하지 않아
// 상태 버튼(OrderStatusButton) 없이 상태 텍스트만 노출
export default function OrderHistoryCardJp({ node }: { node: ICaaOrder }) {
  const { t } = useTranslation();
  const { isPC } = useCheckDevice();

  const { orderStatus } = useOrderStatusCaa(node);

  const trackingInfo = getTrackingInfoCaa(node);

  return (
    <li className="tnt-gap-x pc:grid-cols-12 pc:gap-y-0 grid grid-cols-8 gap-y-2.5">
      <div className="pc:col-span-2 col-span-3 col-start-1">
        <Link as="wrapper" className="flex! flex-col" href={`${URLS.ORDER}${extractId(node.id)}`}>
          <span>{node.name}</span>
          <span>{dayjs(node.processedAt).format("MMM DD, YYYY")}</span>
          <span>{orderStatus ? t(OrderStatusTrans[orderStatus]) : orderStatus}</span>
        </Link>
        {trackingInfo ? (
          <Link as="text" className="w-fit font-normal underline" href={trackingInfo.url ?? ""}>
            {trackingInfo.number}
          </Link>
        ) : null}
      </div>
      {isPC && node.lineItems.edges.length > 0 ? (
        <Link
          as="wrapper"
          className="pc:col-span-3 pc:col-start-3 col-span-3 col-start-3 flex flex-col"
          href={`${URLS.ORDER}${extractId(node.id)}`}
        >
          <ol>
            {node.lineItems.edges.map((item, index) => (
              <li key={`${node.id}-${index}-title`}>
                <span>{item.node.title}</span>
              </li>
            ))}
          </ol>
        </Link>
      ) : null}
      <Link as="wrapper" className="pc:col-span-1 col-span-3 block" href={`${URLS.ORDER}${extractId(node.id)}`}>
        <Price price={parseFloat(node.totalPrice.amount)} />
      </Link>
      <Link
        as="wrapper"
        className="pc:col-span-4 pc:col-start-7 pc:row-start-1 col-span-8 row-start-2 block"
        href={`${URLS.ORDER}${extractId(node.id)}`}
      >
        <ol className="flex flex-wrap gap-1">
          {node.lineItems.edges.map((item, index) => (
            <li key={`${node.id}-${index}-thumbnail`}>
              <Image
                className="pc:w-20 pc:max-w-20 w-15 max-w-15"
                height={1707}
                src={item.node.image?.url || node.featuredImage?.value || ""}
                width={1280}
              />
            </li>
          ))}
        </ol>
      </Link>
      <div className="pc:col-start-11 col-span-2 col-start-7">
        <div className="pc:flex-row pc:gap-2 float-right flex flex-col-reverse items-end gap-1">
          <Link as="text" href={`${URLS.ORDER}${extractId(node.id)}`}>
            {t("view_detail")}
          </Link>
        </div>
      </div>
    </li>
  );
}
